import React, {Component} from 'react';
import {  
  ExpansionPanelDetails,
  Grid,
} from '@material-ui/core';
import _ from 'lodash';
import numberFormatter from 'utils/numberFormatter';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {
  AlignedGrid,
  QuoteComparisonExpansionPanel,
  QuoteComparisonExpansionSummary,  
  QuoteComparisonExpansionPanelDetails,
  RightAlignedDiv,
  CenteredDiv,
  createPeriodLoanGridElements,
  createLoanGridLabel,
  createMoneyLoanGridElements,
  createLoanGridElementsWithRenderer} from './QuoteComparisonGridElements';

class Term extends Component {
  state={
    expanded:true
  }

  handleChange = (event, expanded) => {
    this.setState({
      expanded: expanded
    });
  }

  
  renderRate = (property) => {
    return (loan) => {
      let value = loan[property];
      if(!value && value !== 0)
        return (<RightAlignedDiv>{'\u2014'}</RightAlignedDiv>)
      return (<RightAlignedDiv>{numberFormatter.formatRate(loan[property], 2, '\u2014')}</RightAlignedDiv>)
    }
  }

  renderExtension = (loan) => {
    let extensionOptions = _.get(loan, 'extensionTermsExtensionOptions')
    let extensionTermMonths = _.get(loan, 'extensionTermsExtensionTermMonths')
    let extensionTermsExtensionRemaining = _.get(loan, 'extensionTermsExtensionRemaining')
    
    if(extensionOptions && extensionTermMonths)
      return (<RightAlignedDiv>{`${extensionOptions}, ${extensionTermMonths} month extensions`}</RightAlignedDiv>);
    else if(extensionTermsExtensionRemaining && extensionTermMonths)
      return (<RightAlignedDiv>{`${extensionTermsExtensionRemaining}, ${extensionTermMonths} month extensions remaining`}</RightAlignedDiv>);
    else if(extensionTermMonths)
      return (<RightAlignedDiv>{`--, ${extensionTermMonths} month extensions`}</RightAlignedDiv>);
    else if(extensionTermsExtensionRemaining)
      return (<RightAlignedDiv>{`${extensionTermsExtensionRemaining} extensions remaining`}</RightAlignedDiv>);
    else 
      return (<RightAlignedDiv>N/A</RightAlignedDiv>);
  }

  renderExtensionTerms = (loan) => {
    let loanExtensions = _.get(loan, 'loanExtensions');
    if(!loanExtensions) 
      return (<RightAlignedDiv>{'\u2014'}</RightAlignedDiv>);

      return (<div>
        {loanExtensions.map((extension, index) => {          
          let extensionTermMonths = _.get(extension, 'extensionTerm');
          let extensionFee = _.get(extension, 'extensionFee');
          let renderedExtensionNumber = (<div style={{fontWeight: '600'}}>Extension {index+1}</div>);
          let renderedExtensionTermMonths = extensionTermMonths ? (<div>{extensionTermMonths} Months</div>) : (<RightAlignedDiv>{'\u2014'}</RightAlignedDiv>);    
          let renderedExtensionFee = extensionFee ? (<div>{`${numberFormatter.formatRate(extensionFee,2)} Fee`}</div>) : (<RightAlignedDiv>{'\u2014'}</RightAlignedDiv>);
          return (
            <div>
              {renderedExtensionNumber}
              {renderedExtensionTermMonths}
              {renderedExtensionFee}
            </div>
          )
        })}

      </div>)
  }
  
  renderMoney = (property) => {
    return (loan) => {
      let value = loan[property];
      if(!value && value !== 0)
        return (<RightAlignedDiv>{'\u2014'}</RightAlignedDiv>)
      return (<RightAlignedDiv>{numberFormatter.formatMoney(loan[property], 2, '\u2014')}</RightAlignedDiv>)
    }
  }
  
  render(){
    const {loans,isCombined} = this.props;
    const {expanded} = this.state;    
    return (
    <QuoteComparisonExpansionPanel onChange={this.handleChange} defaultExpanded>
      <QuoteComparisonExpansionSummary expandIcon={<ExpandMoreIcon />}>
        <Grid container direction="row" alignItems="stretch">
            {createLoanGridLabel("Term")}
            {expanded && createPeriodLoanGridElements(loans, 'loanTermMonths',isCombined )}
        </Grid>
      </QuoteComparisonExpansionSummary>
      {/* <QuoteComparisonExpansionPanelDetails>
          <AlignedGrid container direction="row" justify="flex-start" alignItems="stretch">
            {createLoanGridLabel("Extensions")}
            {createLoanGridElementsWithRenderer(loans, this.renderExtension,'\u2014',isCombined)}
          </AlignedGrid>
      </QuoteComparisonExpansionPanelDetails> */}
      <QuoteComparisonExpansionPanelDetails>
          <AlignedGrid container direction="row" justify="flex-start" alignItems="stretch">
            {createLoanGridLabel("Extension Terms")}
            {createLoanGridElementsWithRenderer(loans, this.renderExtensionTerms,'\u2014',isCombined)}
          </AlignedGrid>
      </QuoteComparisonExpansionPanelDetails>
      <QuoteComparisonExpansionPanelDetails>
          <AlignedGrid container direction="row" justify="flex-start" alignItems="stretch">
            <Grid item xs={12}></Grid>
            {createLoanGridLabel("Extension Fees Amount")}
            {createMoneyLoanGridElements(loans, 'extensionTermsExtensionFeeAmt',isCombined)}
          </AlignedGrid>
        </QuoteComparisonExpansionPanelDetails>
    </QuoteComparisonExpansionPanel>
    )
  }
}

export default Term;